import { useCheckInCheckOut } from "@/hooks/query-hooks/useCheckInCheckOut";
import { Button } from "antd";

export function CheckInOutHandler({
	userId,
	closeModal,
}: {
	userId: number;
	closeModal: () => void;
}) {
	const { mutate, isPending } = useCheckInCheckOut();

	const handleCheckInOut = () => {
		mutate(userId, {
			onSuccess: () => {
				closeModal();
			},
		});
	};

	return (
		<Button
			className="bg-primary-gradient !font-poppins !rounded-md"
			size="large"
			type="primary"
			block
			onClick={handleCheckInOut}
			loading={isPending}
		>
			Check In / Out
		</Button>
	);
}
